import { useInView } from "@/hooks/use-in-view"
import { FeatureCard } from "@/components/custom/landing/feature-card"
import { CalendarDays, Flame, TrendingUp, RefreshCw, Download, BarChart2 } from "lucide-react"

const FEATURES = [
	{
		icon: <TrendingUp className="h-8 w-8 text-sky-700 dark:text-sky-400 fill-sky-700/20 dark:fill-sky-400/20" />,
		title: "Dividend Forecast",
		description: "12-month income projection with paid, declared, and predicted events — updated automatically.",
	},
	{
		icon: <Flame className="h-8 w-8 text-sky-700 dark:text-sky-400 fill-sky-700/20 dark:fill-sky-400/20" />,
		title: "FIRE Dashboard",
		description: "Income coverage %, years to freedom, milestones, and 50-year projections.",
	},
	{
		icon: <RefreshCw className="h-8 w-8 text-sky-700 dark:text-sky-400 fill-sky-700/20 dark:fill-sky-400/20" />,
		title: "Investment Simulator",
		description: "50-year DRIP calculator with configurable contributions and income targets.",
	},
	{
		icon: <CalendarDays className="h-8 w-8 text-sky-700 dark:text-sky-400 fill-sky-700/20 dark:fill-sky-400/20" />,
		title: "Calendar & ICS Feed",
		description: "Subscribe from Apple Calendar, Google Calendar, or Outlook. Never miss a payment.",
	},
	{
		icon: <Download className="h-8 w-8 text-sky-700 dark:text-sky-400 fill-sky-700/20 dark:fill-sky-400/20" />,
		title: "CSV Import & Export",
		description: "Migrate from any brokerage in minutes. Export transactions and dividends any time.",
	},
	{
		icon: <BarChart2 className="h-8 w-8 text-sky-700 dark:text-sky-400 fill-sky-700/20 dark:fill-sky-400/20" />,
		title: "Earnings Calendar",
		description:
			"EPS estimates, beat/miss results, and report timing (pre/post market) — alongside your dividend events.",
	},
]

export function FeatureGrid() {
	const { ref, inView } = useInView()

	return (
		<div ref={ref} className={`transition-opacity duration-700 ease-out ${inView ? "opacity-100" : "opacity-0"}`}>
			<section className="py-20 px-4">
				<div className="max-w-6xl mx-auto">
					<div className="text-center mb-12">
						<h2 className="text-3xl sm:text-4xl font-bold text-sky-950 dark:text-sky-50">
							Everything you need to track dividends
						</h2>
						<p className="mt-3 text-base sm:text-lg text-sky-900/65 dark:text-sky-300/55">
							All features available today. No holding limits.
						</p>
					</div>
					<div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
						{FEATURES.map(({ icon, title, description }) => (
							<FeatureCard key={title} icon={icon} title={title} description={description} />
						))}
					</div>
				</div>
			</section>
		</div>
	)
}
